import { ajax } from '../../../services/helper'
class ApiService {

    getRolesData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/roles/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    addRoles = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/roles/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getRolesById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/roles/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     editRoles = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/roles/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    
     getPrivilegesComboList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/privileges/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Roles/services/apiservices.js